module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as1506-9c879dbd652cba3c4d520596b22a37e2.jpg";